import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    name: String,
    skus: String,
    url: String
  }

  similar(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const message = `Please show me products similar to the ${this.nameValue} (skus: ${this.skusValue} | url: ${this.urlValue})`
    this.populateChatInput(message)
  }

  compare(event) {
    event.preventDefault()
    event.stopPropagation()

    const message = `How does the ${this.nameValue} (skus: ${this.skusValue} | url: ${this.urlValue}) compare to other similar products?`
    this.populateChatInput(message)
  }

  populateChatInput(message) {
    // Try to find the chat input in various likely locations
    // 1. The standard chat input in canvases/show
    let input = document.getElementById("chat-input")
    
    // 2. Fallback to any textarea with message[content] name (standard Rails convention)
    if (!input) {
      input = document.querySelector('textarea[name="message[content]"]')
    }

    if (input) {
      input.value = message
      input.focus()
      
      // Trigger input event for autogrow controllers
      input.dispatchEvent(new Event('input', { bubbles: true }))
      
      // If there's a send button that's hidden until input, this might help trigger its visibility
      // checking for the send button logic in canvases/show:
      // It uses expert-qa-target="sendBtn" and checks input value on input event.
      // So dispatching 'input' should be enough.
    } else {
      console.warn("Chat input not found")
    }
  }
}
